import type { FC } from 'react';
import { Col, Menu, Row } from 'antd';

import { AppIcon } from '@/assets';
import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface CountercyclicalDropdownFooterProps {
    flushTop?: boolean;
}

const CountercyclicalDropdownFooter: FC<CountercyclicalDropdownFooterProps> = ({ flushTop = false }) => {
    const { token } = useAntDesignTheme();

    return (
        <>
            <Menu.Divider style={flushTop ? { margin: 0 } : { marginBottom: 0 }} />
            <Menu.Item
                key='company'
                onClick={() => window.open('https://countercyclical.io', '_blank', 'noopener,noreferrer')}
                style={{
                    backgroundColor: token.colorBgBase,
                    paddingBottom: '0.5rem',
                    paddingTop: '0.5rem',
                }}
            >
                <Row>
                    <Col flex='auto' style={{ textAlign: 'left' }}>
                        <img
                            alt='Countercyclical - App Icon'
                            height={16}
                            src={AppIcon}
                            style={{ verticalAlign: '-0.2rem' }}
                            width={16}
                        />
                        <span style={{ fontWeight: 500, marginLeft: '0.5rem' }}>Countercyclical</span>
                    </Col>
                </Row>
            </Menu.Item>
        </>
    );
};

export default CountercyclicalDropdownFooter;
